module.exports = __webpack_public_path__ + "img/camera.9d0fb4fd.svg";